<template>
  <div id="app" >
    <router-view/>
    <div ref="splashscreen" class="splashscreen" :class="{ 'splashscreen--hide': splashscreen }">
      <div class="splashscreen__content">
        <img class="splashscreen__logo" ref="logo" :src="logo" alt="">
        <div class="text">
          <div class="overflowh">
            <p ref="title1">Le fil est une expérience interactive qui tisse l’actualité </p>
          </div>
          <div class="overflowh">
            <p ref="title2">du jour et propose une exploration en temps réel</p>
          </div>
          <div class="overflowh">
            <p ref="title3">de plusieurs fils d’actualités.</p>
          </div>
        </div>
      </div>
      <div class="splashscreen__scroll" :class="{ 'visible': scrollVisible && authenticate }">
        <span>Scroll pour lancer l'expérience</span>
        <img :src="arrowbot" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { TimelineLite, Power2 } from 'gsap';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import vuescroll from 'vue-scroll';
import Vue from 'vue';
import FontFaceObserver from 'fontfaceobserver';
import logo from './assets/images/logo.gif';
import arrowbot from './assets/images/arrowbot.svg';

Vue.use(vuescroll);
export default {
  name: 'App',
  data() {
    return {
      logo,
      arrowbot,
      timeline: null,
      scrollVisible: false,
    };
  },
  computed: {
    ...mapGetters([
      'authenticate',
      'splashscreen',
      'channels',
      'currentChannel',
      'currentSlug',
    ]),
  },
  methods: {
    ...mapMutations([
      'isAuthenticate',
      'isSplashcreen',
    ]),
    ...mapActions([
      'authenticateAPI',
      'loadChannelsByUserId',
      'getChannelById',
      'updateSlug',
    ]),
    go(id = this.currentChannel.id) {
      this.$router.push(`/c/${id}`);
    },
    onScroll() {
      if (this.scrollVisible) {
        this.isSplashcreen();
      }
    },
  },
  created() {
    const Fonts = [
      new FontFaceObserver('TrioGrotesk', { weight: 500 }),
      new FontFaceObserver('Sailec', { weight: 500 }),
    ];

    if (!this.$route.params.channelId) {
      this.go();
    } else {
      this.getChannelById(this.$route.params.channelId)
        .then((channel) => {
          if (!channel) this.updateSlug(this.$route.params.channelId.replace('-', ' '));
        });
    }

    Promise.all([
      ...Fonts.map(f => f.load()),
      this.authenticateAPI(),
      this.loadChannelsByUserId(), // TODO : connect user same time to API token
    ])
      .then(() => this.isAuthenticate());
  },
  watch: {
    currentSlug(newCurrentSlug) {
      if (newCurrentSlug) this.go(newCurrentSlug);
    },
  },
  mounted() {
    this.$refs.splashscreen.addEventListener('wheel', (e) => {
      if (!e.ctrlKey && e.deltaY > 1 && this.authenticate && this.scrollVisible) {
        this.isSplashcreen();
      }
    }, { passive: true });

    this.timeline = new TimelineLite({
      pause: true,
      autoRemoveChildren: true,
      useFrames: false,
    });

    this.timeline
      .to(this.$refs.logo, 0.35, {
        opacity: 0,
        ease: Power2.easeOut,
      }, 4.6)
      .to(this.$refs.title1, 0.7, {
        top: 0,
        ease: Power2.easeOut,
      }, 5)
      .to(this.$refs.title2, 0.7, {
        top: 0,
        ease: Power2.easeOut,
      }, '-=0.3')
      .to(this.$refs.title3, 0.7, {
        top: 0,
        ease: Power2.easeOut,
      }, '-=0.3')
      .to(this, 0.8, {
        onComplete: () => {
          this.scrollVisible = true;
        },
      });
  },
};
</script>

<style lang="scss">
  @font-face {
    font-family: 'TrioGrotesk';
    src: url('assets/fonts/Trio_Grotesk/Trio_Grotesk_Normal.otf') format('truetype');
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: 'Sailec';
    src: url('assets/fonts/Sailec/Sailec_Light.otf') format('truetype');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'Sailec';
    src: url('assets/fonts/Sailec/sailec-regular.otf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }
  html, body {
    margin: 0;
    height: 100%;
    overflow: hidden;
  }
  #app {
    height: 100%;
  }
  .splashscreen {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
    opacity: 0.99;
    background-color: #ffffff;
    transition: .5s ease;
    text-align: center;
    &--hide {
      display: none;
    }

    &__logo {
      width: 300px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
    }

    strong {
      position: relative;
      bottom: -100px;
    }

    .text {
      font-family: 'Sailec';
      font-size: 17px;
      text-align: center;
      font-weight: bold;
    }

    .overflowh {
      overflow: hidden;
      margin-bottom: 8px;
      p {
        text-transform: uppercase;
        letter-spacing: 3.2px;
        margin: 0;
        padding: 0;
        position: relative;
        bottom: -100px;
      }
    }

    &__content {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    &__scroll {
      position: fixed;
      bottom: 50px;
      display: block;
      text-align: center;
      width: 100vw;
      font-size: 15px;
      letter-spacing: 3.2px;
      font-family: 'Sailec';
      text-transform: uppercase;
      opacity: 0;
      &.visible {
        opacity: 1;
        transition: opacity 0.2s;
      }
      img {
        width: 10px;
        display: block;
        margin: 10px auto 0 auto;
        position: relative;
        animation: bounce
        0.8s
        ease
        alternate
        infinite;
      }
    }
  }

  @-webkit-keyframes bounce {
     from {top: -2px;}
     to {top: 2px;}
   }

  @-webkit-keyframes flash {
    from {opacity: 1;}
    to {opacity: 0;}
  }
</style>



// WEBPACK FOOTER //
// src/App.vue